const NULL_VALUE_PATTERN = "null null";
const DEFAULT_EMPTY_VALUE = " - ";

const Strings = {};

Strings.orEmpty = function (entity) {
  return entity || "";
};

Strings.fullname = function (first, lastName) {
  return `${this.orEmpty(first)} ${this.orEmpty(lastName)}`;
};

Strings.formatContactValue = function (value) {
  if (!value || value.trim() === NULL_VALUE_PATTERN) {
    return DEFAULT_EMPTY_VALUE;
  }
  return value;
};

export { Strings };
